<div class="repeatable-cell" [formGroup]="rowGroup">
    <label class="field-label">{{ sf.label ?? sf.key }}</label>

    @switch (sf.input.type) {
        @case (INPUT.ONLY_TEXT) {
            <p class="read-only">{{ onlyText }}</p>
        }

        @case (INPUT.NUMERIC) {
            <input
                *ngIf="isEditable; else readOnly"
                pInputText
                type="number"
                [formControlName]="sf.key"
                placeholder="..."
                [readonly]="!isEditable || !sf.input.isEditable"
                [ngClass]="numericInputClasses"
            />
        }

        @case (INPUT.TEXT) {
            <input
                *ngIf="isEditable; else readOnly"
                pInputText
                type="text"
                [formControlName]="sf.key"
                placeholder="..."
                [attr.maxlength]="sf.input.maxLength ?? null"
                [attr.aria-invalid]="hasVisibleError(sf.key)"
                [attr.aria-describedby]="hasVisibleError(sf.key) ? errorId(sf.key) : null"
                [readonly]="!isEditable || !sf.input.isEditable"
            />
        }

        @case (INPUT.PASSWORD) {
            <input
                *ngIf="isEditable; else readOnly"
                pInputText
                type="password"
                [formControlName]="sf.key"
                placeholder="..."
                [readonly]="!isEditable || !sf.input.isEditable"
            />
        }

        @case (INPUT.TEXTAREA) {
            <textarea
                pTextarea
                class="w-100"
                [rows]="sf.input.textAreaConfiguration?.rows ?? 3"
                [cols]="sf.input.textAreaConfiguration?.cols ?? 20"
                [readonly]="!isEditable || !sf.input.isEditable"
                [formControlName]="sf.key"
                placeholder="..."
            ></textarea>
        }

        @case (INPUT.TEXT_MASK) {
            <p-inputMask
                *ngIf="isEditable; else readOnly"
                [formControlName]="sf.key"
                [mask]="sf.input.textMaskConfiguration?.mask ?? ''"
                [placeholder]="sf.input.textMaskConfiguration?.mask ?? ''"
            ></p-inputMask>
        }

        @case (INPUT.DROPDOWN) {
            <p-select
                *ngIf="isEditable; else readOnly"
                [formControlName]="sf.key"
                optionLabel="label"
                optionValue="value"
                [options]="dropdownOptions"
                [disabled]="!isEditable || !sf.input.isEditable"
            ></p-select>
        }

        @case (INPUT.DROPDOWN_SEARCH) {
            <p-select
                *ngIf="isEditable; else readOnly"
                [formControlName]="sf.key"
                [virtualScroll]="true"
                [virtualScrollItemSize]="40"
                [options]="dropdownOptions"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [disabled]="!isEditable || !sf.input.isEditable"
            ></p-select>
        }

        @case (INPUT.MULTISELECT) {
            <p-listbox
                *ngIf="isEditable; else readOnly"
                [options]="dropdownOptions"
                optionLabel="label"
                optionValue="value"
                [metaKeySelection]="false"
                [checkbox]="true"
                [multiple]="true"
                [showToggleAll]="false"
                [listStyle]="{
                    'max-height': sf.input.dropdownConfiguration?.hasMaxHeight ? '100%' : '15rem',
                    'min-height': '18px'
                }"
                [formControlName]="sf.key"
                [disabled]="!isEditable || !sf.input.isEditable"
            ></p-listbox>
        }

        @case (INPUT.MULTISELECT_SEARCH) {
            <p-multiselect
                *ngIf="isEditable; else readOnly"
                [options]="dropdownOptions"
                [formControlName]="sf.key"
                optionLabel="label"
                optionValue="value"
                [filter]="true"
                filterBy="label"
                [showToggleAll]="true"
                placeholder="Seleccionar"
                [maxSelectedLabels]="3"
                styleClass="w-full md:w-80"
                [disabled]="!isEditable || !sf.input.isEditable"
            ></p-multiselect>
        }

        @case (INPUT.CALENDAR) {
            <p-datePicker
                #datePicker
                *ngIf="isEditable; else readOnly"
                [ngModel]="calendarControlValue(sf.key)"
                [ngModelOptions]="standaloneNgModelOptions"
                [firstDayOfWeek]="1"
                [dateFormat]="calendarDateFormat"
                [disabledDates]="sf.input.calendarConfiguration?.disabledDates ?? []"
                (ngModelChange)="onCalendarValueChange($event, sf.key)"
                (onSelect)="onCalendarSelect($event, sf.key, datePicker)"
                [dataType]="'string'"
                [hideOnDateTimeSelect]="true"
                placeholder="..."
                [appendTo]="'body'"
                [view]="sf.input.calendarConfiguration?.calendarView ?? 'date'"
                [disabled]="!isEditable || !sf.input.isEditable"
            ></p-datePicker>
        }

        @case (INPUT.TIME) {
            <p-datePicker
                *ngIf="isEditable; else readOnly"
                [formControlName]="sf.key"
                [timeOnly]="true"
                hourFormat="24"
                placeholder="..."
                dateFormat="hh:mm"
                dataType="string"
                [disabled]="!isEditable || !sf.input.isEditable"
            ></p-datePicker>
        }

        @case (INPUT.SWITCH) {
            @if (!isEditable) {
                <div style="pointer-events: none;">
                    <p-toggleswitch
                        [formControlName]="sf.key"
                        [trueValue]="1"
                        [falseValue]="0"
                    ></p-toggleswitch>
                </div>
            } @else {
                <p-toggleswitch
                    [formControlName]="sf.key"
                    [trueValue]="1"
                    [falseValue]="0"
                    [disabled]="!sf.input.isEditable"
                ></p-toggleswitch>
            }
        }

        @default {
            <input
                *ngIf="isEditable; else readOnly"
                pInputText
                type="text"
                [formControlName]="sf.key"
                placeholder="..."
                [readonly]="!isEditable || !sf.input.isEditable"
            />
        }
    }

    @if (hasVisibleError(sf.key)) {
        <small [id]="errorId(sf.key)" class="p-error d-block mt-1" role="alert">
            {{ errorMessage(sf.key) }}
        </small>
    }

    <ng-template #readOnly>
        <p class="read-only">{{ readOnlyText }}</p>
    </ng-template>
</div>
